// extracted by mini-css-extract-plugin
export default {"reaction":"Reaction_reaction__kCxXy","selected":"Reaction_selected__omflS","like":"Reaction_like__8SOsD","dislike":"Reaction_dislike__rWbCL"};